import system from './system';
import Index from '@/view/Index';
import ReceiveCoupon from '@/view/ReceiveCoupon';
import ReceiveCouponSuccess from '@/view/ReceiveCouponSuccess';
import ReceiveCouponError from '@/view/ReceiveCouponError';
const router = [
  ...system,
  {
    path: '/index',
    element: Index,
    meta: {
      title: '我是首页',
      isHeader: true, //是否展示顶部header
    },
  },
  {
    path: '/receiveCoupon',
    element: ReceiveCoupon,
    meta: {
      title: '活动',
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/receiveCouponSuccess',
    element: ReceiveCouponSuccess,
    meta: {
      title: '领取成功',
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/receiveCouponError',
    element: ReceiveCouponError,
    meta: {
      title: '领取失败',
      isHeader: false, //是否展示顶部header
    },
  },
]

export default router;
